const QuestionType = {
  SCQ: 1, // 单选
  MCQ: 2, // 多选
  SBQ: 3, // 填空
  MBQ: 4, // 多项填空
  DLQ: 5, // 下拉 
  NPS: 6, // NPS
  VOTE: 7, // 投票
  SORT: 8, // 排序
  REMARK: 9, // 备注
  SCORE: 10, // 分数评定
  QA: 11, // 问答
  WRQ: 12, // 权重评分
  SRQ: 13, // 评星
  NAME: 14, // 姓名
  GENDER: 15, // 性别
  AGE: 16, // 年龄
  TEL: 17, // 电话号
  EMAIL: 18, // 邮箱
  DATE: 19, // 日期
  TIME: 20, // 时间
  ADDR: 21 // 地址
}

export {
  QuestionType
}


// WEBPACK FOOTER //
// ./src/components/constant.js